/**
 * Zod-free constants. The browser component imports from here so the
 * validation library stays out of the frontend bundle.
 */

/** Bump when the request body shape changes in a way old clients cannot satisfy. */
export const LEAD_SCHEMA_VERSION = 1 as const;

export const MAX_TEXT = 200;
export const MAX_URL = 2048;
